import { z, infer as ZodInfer } from "zod"
import { ProjectExtended, projectExtendedSchema } from "./projects"

export const tagRecordSchema = z.object({
    id: z.string(),
    sk: z.string(),
    createdAt: z.string(),
    createdBy: z.string(),
    fullName: z.string(),
    rootId: z.string(),
    parentId: z.string().optional(),
    updatedAt: z.string(),
    updatedBy: z.string().optional(),
})

export const tagSchema = z.object({
    id: z.string(),
    createdAt: z.string(),
    createdBy: z.string(),
    name: z.string(),
    orgId: z.string(),
    parentId: z.string().optional(),
    updatedAt: z.string(),
    updatedBy: z.string().optional(),
})

export type TagRecord = ZodInfer<typeof tagRecordSchema>
export type Tag = ZodInfer<typeof tagSchema>
export type TagExtended = Tag & { subTags: TagExtended[]; projects: ProjectExtended[] }

export const tagExtendedSchema: z.ZodType<TagExtended> = tagSchema.extend({
    subTags: z.lazy(() => tagExtendedSchema).array(),
    projects: z.array(projectExtendedSchema),
})
